import { TimeReportResolution, TimeReportStatusV2 } from "model/TimeReport";
import { isTimeReportAbsenceResolution } from "web-apps/company/utils/absenceLabels";

export interface TimeReportActionPolicy {
  hasVisibleActions: boolean;
  showRetractAction: boolean;
  showAbsenceAction: boolean;
  showRejectAction: boolean;
  showApproveAction: boolean;
  showResetAction: boolean;
}

/**
 * Resolves available time-report actions from status/resolution.
 * Shared by detail-panel actions and person-view bulk-action rules.
 */
export const resolveTimeReportActionPolicy = (
  status: TimeReportStatusV2 | null | undefined,
  resolution: TimeReportResolution | null | undefined,
): TimeReportActionPolicy => {
  const isUnsubmitted = status === TimeReportStatusV2.NEW;

  const isSubmitted = status === TimeReportStatusV2.SUBMITTED;

  const isClosed = status === TimeReportStatusV2.CLOSED;

  const isClosedTimeReported =
    isClosed && resolution === TimeReportResolution.TIME_REPORTED;

  const isClosedWithdrawn =
    isClosed && resolution === TimeReportResolution.WITHDRAWN;

  const isClosedAbsence =
    isClosed && resolution != null && isTimeReportAbsenceResolution(resolution);

  const isClosedOverdue =
    isClosed && resolution === TimeReportResolution.OVERDUE;

  const showRetractAction =
    isUnsubmitted || isSubmitted || isClosedTimeReported;

  const showAbsenceAction = isUnsubmitted || isSubmitted;

  const showRejectAction = isSubmitted;

  const showApproveAction = isUnsubmitted || isSubmitted;

  const showResetAction =
    isClosedTimeReported || isClosedWithdrawn || isClosedAbsence;

  const hasVisibleActions =
    !isClosedOverdue &&
    (showRetractAction ||
      showAbsenceAction ||
      showResetAction ||
      showRejectAction ||
      showApproveAction);

  return {
    hasVisibleActions,
    showRetractAction,
    showAbsenceAction,
    showRejectAction,
    showApproveAction,
    showResetAction,
  };
};
